import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeUser, changeWallet } from "../App/Slices/userSlice";
import { RootState } from "../App/store";
import { User } from "../Interfaces/bucket/User";
import AuthService from "../Services/AuthService";
import ToastService from "../Services/ToastService";
import "./Authorization.scss";
import { useNavigate } from "react-router-dom";
// import PassPopover from "./PassPopover/PassPopover";
import ConnectWallet from "../components/ConnectWallet/ConnectWallet";
import DataService from "../Services/DataService";
import Spinner from "../components/shared/Spinner/Spinner";
import BackWebsite from "../components/shared/BackWebsite/BackWebsite";

const Authorization = () => {
  const userSelector = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<string>("login");
  // const [wallet, setWallet] = useState<string>("");
  const [pinNickName, setPinNickName] = useState<string>("");

  const usernameRegex = /^([a-z0-9A-Z]|[-._](?![-._])){4,20}$/;

  // const regEmail: any = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const [registerForm, setRegisterForm] = useState<any>({
    // password: "",
    // confirmPassword: "",
    openPopup: false,
    valid: false,
    nick_name_valid: false,
    nick_name: "",
    loading: false,
  });
  let [loginForm, setLoginForm] = useState<any>({
    // password: "",
    openPopup: false,
    valid: false,
  });
  // const [forgetPassForm, setForgetPassForm] = useState<any>({
  //   password: "",
  //   confirmPassword: "",
  //   openPopup: false,
  //   valid: false,
  //   email: "",
  //   code: "",
  // });

  // const validEmail = useCallback((email: string) => {
  //   return regEmail.test(email);
  // }, []);

  // const sendVerifyCode = useCallback(() => {
  //   AuthService.recoveryPassword(forgetPassForm.email)
  //     .then(() => {
  //       setActiveTab("verification_code");
  //       ToastService.success("We send a verification code to your email.");
  //     })
  //     .catch((e) => ToastService.error(e.error.message));
  // }, []);

  // const verifyCode = () => {
  //   AuthService.verifyCode(
  //     forgetPassForm.email,
  //     forgetPassForm.code,
  //     "forgot_password"
  //   )
  //     .then(() => {
  //       setActiveTab("new_password");
  //       ToastService.success("Verification success. <br> Set the new password");
  //     })
  //     .catch((e) => ToastService.error(e.error.message));
  // };
  // const changePassword = () => {
  //   AuthService.setNewPassword(
  //     forgetPassForm.email,
  //     forgetPassForm.password,
  //     wallet
  //   )

  //     .then(() => {
  //       ToastService.success(
  //         "New password successfuly saved. <br> Going to login"
  //       );
  //       goToLogin();
  //     })
  //     .catch((e) => ToastService.error(e.error.message));
  // };
  const login = () => {
    setButtonLoading(true);

    AuthService.login(userSelector.wallet as string)
      .then(async (res) => {
        ToastService.success("Login Success");

        localStorage.setItem("spicaToken", res.data.token);
        localStorage.setItem("spicaUserId", res.data._id);

        setButtonLoading(false);
        dispatch(changeUser(res.data as User));
        setTimeout(() => {
          navigate("/");
        }, 1000);
      })
      .catch((e) => {
        setButtonLoading(false);
        ToastService.error(e.response.data.message);
      });
  };

  const register = () => {
    setButtonLoading(true);
    AuthService.register(
      // registerForm.password,
      userSelector.wallet?.toString() as string,
      registerForm.nick_name
    )
      .then(() => {
        ToastService.success("Registiration Success");
        goToLogin();
        setButtonLoading(false);
      })
      .catch((e) => {
        ToastService.error(e.response.data.message);
        setButtonLoading(false);
      });
  };

  const goToLogin = () => {
    setTimeout(() => {
      setActiveTab("login");
    }, 1000);
  };

  useEffect(() => {
    if (!pinNickName || !usernameRegex.test(pinNickName)) {
      setRegisterForm({
        ...registerForm,
        loading: false,
        nick_name_valid: false,
      });
      return;
    }

    const getData = setTimeout(() => {
      setRegisterForm({
        ...registerForm,
        loading: true,
      });
      DataService.resources.user
        .getAll({
          queryParams: {
            filter: {
              nick_name: { $regex: registerForm.nick_name, $options: "i" },
            },
            limit: 1,
          },
        })
        .then((response: User[]) => {
          setRegisterForm({
            ...registerForm,
            loading: false,
            nick_name_valid: !response.length,
          });
          clearTimeout(getData);
        });
    }, 500);

    return () => clearTimeout(getData);
  }, [pinNickName]);

  useEffect(() => {
    setButtonLoading(false);
    setRegisterForm({});
    setLoginForm({});
  }, [activeTab]);

  return (
    <div className="Authorization">
      <div
        className="Layout"
        style={{
          backgroundImage: `url(${
            activeTab == "register"
              ? "/assets/authorization/register-background.png"
              : "/assets/authorization/form-background.png"
          })`,
        }}
      >
        <div className="Form">
          <div className="Header">
            <img
              className="Header__logo"
              src="/assets/authorization/BigLogo.png"
              alt=""
            />
          </div>
          {(() => {
            switch (activeTab) {
              case "login":
                return (
                  <div className="login">
                    <form>
                      <ConnectWallet></ConnectWallet>
                      {/* <input
                        name="password"
                        onChange={($event) => {
                          setLoginForm({
                            ...loginForm,
                            password: $event?.target.value,
                          });
                        }}
                        type="password"
                        placeholder="Enter Password..."
                      /> */}
                      <button
                        className="SubmitButton"
                        onClick={(event) => {
                          event.preventDefault();
                          login();
                        }}
                        disabled={
                          buttonLoading ||
                          // !loginForm.password ||
                          !userSelector.wallet
                        }
                      >
                        {buttonLoading ? (
                          <Spinner size={2} renderContent="Log in"></Spinner>
                        ) : (
                          "Log in"
                        )}
                      </button>
                    </form>
                  </div>
                );
              case "register":
                return (
                  <form>
                    <div className="FormField">
                      {registerForm.loading ? (
                        <span className="Suffix__End">
                          <Spinner
                            color="red"
                            position="left"
                            size={1.5}
                          ></Spinner>
                        </span>
                      ) : (
                        ""
                      )}
                      {!registerForm.loading && registerForm.nick_name ? (
                        <span className="Suffix__End">
                          <span
                            className={`NickNameStatus material-symbols-outlined ${
                              registerForm.nick_name_valid
                                ? "NickNameStatus--green"
                                : "NickNameStatus--red"
                            }`}
                          >
                            {registerForm.nick_name_valid
                              ? "check_circle"
                              : "cancel"}
                          </span>
                        </span>
                      ) : (
                        ""
                      )}

                      <input
                        name="nickname"
                        onChange={(event) => {
                          {
                            setRegisterForm({
                              ...registerForm,
                              nick_name: event?.target.value,
                              loading: true,
                            });
                            setPinNickName(event.target.value);
                          }
                        }}
                        placeholder="Nickname"
                      />
                    </div>
{/* 
                    <div className="FormField">
                      {registerForm.openPopup ? (
                        <PassPopover
                          onPasswordChange={(result: boolean) =>
                            (registerForm.valid = result)
                          }
                          passWord={registerForm.password}
                        ></PassPopover>
                      ) : (
                        ""
                      )}
                      <input
                        name="password"
                        type="password"
                        onBlur={() =>
                          setRegisterForm({
                            ...registerForm,
                            openPopup: false,
                          })
                        }
                        onClick={() =>
                          setRegisterForm({
                            ...registerForm,
                            openPopup: true,
                          })
                        }
                        onChange={($event) => {
                          setRegisterForm({
                            ...registerForm,
                            password: $event?.target.value,
                            openPopup: true,
                          });
                        }}
                        placeholder="Password"
                      />
                    </div>
                    <div className="FormField">
                      <input
                        name="confirmPassword"
                        type="password"
                        onChange={($event) =>
                          setRegisterForm({
                            ...registerForm,
                            confirmPassword: $event?.target.value,
                          })
                        }
                        placeholder="Re-enter password"
                      />
                    </div> */}
                    <ConnectWallet></ConnectWallet>

                    <button
                      onClick={(event) => {
                        event.preventDefault();
                        register();
                      }}
                      disabled={
                        // !registerForm.valid ||
                        // registerForm.confirmPassword != registerForm.password ||
                        !registerForm.nick_name ||
                        !registerForm.nick_name_valid ||
                        !userSelector.wallet
                      }
                    >
                      {buttonLoading ? (
                        <Spinner
                          color="black"
                          size={2}
                          renderContent="Register"
                        ></Spinner>
                      ) : (
                        "Register"
                      )}
                    </button>
                  </form>
                );
              // case "forgot_password":
              //   return (
              //     <div className="forgot_password">
              //       <form>
              //         <input
              //           name="email"
              //           onChange={($event) =>
              //             setForgetPassForm({
              //               ...forgetPassForm,
              //               email: $event?.target.value,
              //             })
              //           }
              //           type="email"
              //           pattern={regEmail}
              //           placeholder="Enter Email..."
              //         />
              //         <button
              //           onClick={(event) => {
              //             event.preventDefault();
              //             sendVerifyCode();
              //           }}
              //           disabled={!validEmail(forgetPassForm.email)}
              //         >
              //           Send Code
              //         </button>
              //       </form>
              //     </div>
              //   );
              // case "verification_code":
              //   return (
              //     <div className="verification_code">
              //       <form>
              //         <input
              //           name="verification_code"
              //           onChange={($event) =>
              //             setForgetPassForm({
              //               ...forgetPassForm,
              //               code: $event?.target.value,
              //             })
              //           }
              //           placeholder="Enter Code..."
              //         />
              //         <button
              //           onClick={(event) => {
              //             event.preventDefault();
              //             verifyCode();
              //           }}
              //           disabled={!forgetPassForm.code}
              //         >
              //           Verify Code
              //         </button>
              //       </form>
              //     </div>
              //   );
              // case "new_password":
              //   return (
              //     <div className="new_password">
              //       <form>
              //         {forgetPassForm.openPopup ? (
              //           <PassPopover
              //             onPasswordChange={(result: boolean) =>
              //               (forgetPassForm.valid = result)
              //             }
              //             passWord={forgetPassForm.password}
              //           ></PassPopover>
              //         ) : (
              //           ""
              //         )}
              //         <input
              //           name="password"
              //           type="password"
              //           onChange={($event) =>
              //             setForgetPassForm({
              //               ...forgetPassForm,
              //               password: $event?.target.value,
              //             })
              //           }
              //           onBlur={() =>
              //             setForgetPassForm({
              //               ...forgetPassForm,
              //               openPopup: false,
              //             })
              //           }
              //           placeholder="Enter New Password..."
              //         />
              //         <input
              //           name="confirmPassword"
              //           type="password"
              //           onChange={($event) =>
              //             setForgetPassForm({
              //               ...forgetPassForm,
              //               confirmPassword: $event?.target.value,
              //             })
              //           }
              //           placeholder="Confirm Password..."
              //         />
              //         <button
              //           onClick={(event) => {
              //             event.preventDefault();
              //             changePassword();
              //           }}
              //           disabled={
              //             !forgetPassForm.valid ||
              //             forgetPassForm.confirmPassword !=
              //               forgetPassForm.password
              //           }
              //         >
              //           Change Password
              //         </button>
              //       </form>
              //     </div>
              //   );
            }
          })()}
        </div>
        <div className="Footer">
          {(() => {
            switch (activeTab) {
              case "login":
                return (
                  <div onClick={() => setActiveTab("register")}>
                    Don't have account yet?{" "}
                    <span className="Footer--link">Create account</span>
                  </div>
                );
              case "register":
                return (
                  <div onClick={() => setActiveTab("login")}>
                    Already have an account?{" "}
                    <span className="Footer--link">Log in</span>
                  </div>
                );
            }
          })()}
        </div>
        <div
          className="BackToWebsite"
          style={{
            bottom: `${activeTab == "register" ? "15%" : ""}`,
          }}
        >
          <BackWebsite></BackWebsite>
        </div>
      </div>
    </div>
  );
};

export default Authorization;
